// extracted by mini-css-extract-plugin
module.exports = {"characterCounter":"CharacterCounter_characterCounter__18NNq","counterError":"CharacterCounter_counterError__32VIV"};